import styled from "styled-components/macro";

export const UnstyledButton = styled.button`
  border: none;
  background-color: inherit;
`;
